import { onClickNavToggle } from './head/head.js';

const $advansedSearchBlock = $('.advanced_search');
const $header = $('.main h1');

$(document).on('click', '.js-adv-search-toggle', (evt) => {
    $header.toggle();
    $advansedSearchBlock.toggle();

    evt.preventDefault();
});

$(document).on('click', '.js-adv-search-open', (evt) => {
    $header.hide();
    $advansedSearchBlock.show();
    onClickNavToggle(evt);
});

$(document).on('click', '.js-search-toggle', function() {
    const $this = $(this);
    const target = $this.data('target');
    const $targetEl = $(`.${target}`);

    if ($targetEl.css('display') === 'none') {
        $this.text($this.data('txt-close'));
        $(window).trigger('multiselect-truncate-refresh');
    } else {
        $this.text($this.data('txt-open'));
    }

    $this.toggleClass('active');
    $targetEl.slideToggle();
});

$('#keyword').flexdatalist({
    minLength: 1,
    searchContain: true,
    selectionRequired: true,
});

$('.advanced_search__reset--filter').on('click', function () {
    if (resetFilter()) {
        submitSearch();
    }
});

$('.advanced_search__reset--search').on('click', function () {
    let changed = resetFilter();
    const $searchInput = $('.input-text__search');

    if (!!$searchInput.val()) {
        changed = true;
        setTimeout(function () {
            $searchInput.val('');
        }, 1);
    }

    if (changed) {
        submitSearch();
    }
});

function resetFilter() {
    let changed = false;
    const $filter = $('.js-form-search');

    $filter.find('select').each(function () {
        const $self = $(this);

        if (!!$self.val().length) {
            changed = true;
            setTimeout(function () {
                $self.val(null).trigger('change');
            }, 1);
        }
    });

    $filter.find('input').each(function () {
        const $self = $(this);

        if (!!$self.val()) {
            changed = true;
            setTimeout(function () {
                $self.val('');
            }, 1);
        }
    });

    return changed;
}

function submitSearch() {
    setTimeout(function () {
        $('#submit-search').click();
    }, 300);
}


// WEBPACK FOOTER //
// ./js/main/module/advanced-search.js